import './style/CreateAccount.css';
import React, { useEffect, useState } from 'react';
import google from '../../media/google.png';
import ShieldDisplay from '../../media/shield-display-styled@3x.png';
import PowDisplay from '../../media/pow-display-styled@3x.png';
import Icon from './Icon';
import CheckmarkDotted from '../../media/checkmark-dotted-display-styled@3x.png';
import Divider from './Divider';
import { useSelector } from 'react-redux';
import SimpleLoader from './SimpleLoader';
import { Text } from '@harperai/materialize-design-system';

const CreateAccount = ({ handleCredentialAccountCreate, handleCredentialAccountCreateFromInvite, handleGoogleAccountCreate, handleGoogleAccountCreateFromInvite }) => {
    const keystoneInterfaceModalType = useSelector((state) => state?.keystoneInterface?.modalType);
    const keystoneInterfaceInviteVerified = useSelector((state) => state?.keystoneInterface?.inviteVerified);

    const [userEmail, setUserEmail] = useState(null);
    const [loginLoading, setLoginLoading] = useState(false);

    const handleCredentialAccountCreateClick = () => {
        setLoginLoading(true);

        if (keystoneInterfaceModalType === "create-account") {
            handleCredentialAccountCreate(userEmail);
        } else if (keystoneInterfaceModalType === "create-account-invite") {
            handleCredentialAccountCreateFromInvite(userEmail);
        }
    };

    const handleGoogleAccountCreateClick = () => {
        setLoginLoading(true);

        if (keystoneInterfaceModalType === "create-account") {
            handleGoogleAccountCreate();
        } else if (keystoneInterfaceModalType === "create-account-invite") {
            handleGoogleAccountCreateFromInvite();
        }
    };

    function isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    useEffect(() => {
        if (keystoneInterfaceInviteVerified?.recipient?.email) {
            setUserEmail(keystoneInterfaceInviteVerified?.recipient?.email);
        }
    }, [keystoneInterfaceInviteVerified?.recipient?.email]);

    return (
        <div id="keystone-create-account" className={`${keystoneInterfaceModalType === "create-account-invite" ? "invite" : ""} `}>
            <div id="create-account-wrapper" className={`product-horizontal-container flex-1`}>
                {keystoneInterfaceModalType === "create-account" && (
                    <div id="create-account-details-pane" className="product-vertical-container flex-1 justify-center v-gap-display">
                        <div className="product-horizontal-container align-center h-gap-m">
                            <Icon icon={ShieldDisplay} size={64} mask={false} />
                            <div className="product-vertical-container">
                                <Text header={3} size="title" bold={true}>Privacy Guarantee</Text>
                                <Text>Corporately identifiable information is never shared.</Text>
                            </div>
                        </div>
                        <div className="product-horizontal-container align-center h-gap-m">
                            <Icon icon={CheckmarkDotted} size={64} mask={false} />
                            <div className="product-vertical-container">
                                <Text header={3} size="title" bold={true}>No Commitment</Text>
                                <Text>You are not required to accept or enable offers on your inventory.</Text>
                            </div>
                        </div>
                        <div className="product-horizontal-container align-center h-gap-m">
                            <Icon icon={PowDisplay} size={64} mask={false} />
                            <div className="product-vertical-container">
                                <Text header={3} size="title" bold={true}>Automatic Negotiation</Text>
                                <Text>We leverage market insights to reclaim you the most capital.</Text>
                            </div>
                        </div>
                    </div>
                )}
                <div id="create-account-content-wrapper" className={`${keystoneInterfaceModalType === "create-account-invite" ? "invite" : ""} product-vertical-container flex-1`}>
                    <div id="create-account-header-wrapper" className="product-vertical-container flex-1 gap-xs">
                        {keystoneInterfaceModalType === "create-account-invite" && keystoneInterfaceInviteVerified && (
                            <div className='product-vertical-container flex-1 gap-xs'>
                                <Text header={2} size="h6" bold={true} variant="yellow">You've been invited!</Text>
                                <div className='product-vertical-container flex-1 v-gap-s'>
                                    <Text variant="white" bold={true}>{`${keystoneInterfaceInviteVerified?.sender?.first_name} has invited you to join their organization on Materialize.`}</Text>
                                </div>
                            </div>
                        )}
                        {(keystoneInterfaceModalType !== "create-account-invite" || !keystoneInterfaceInviteVerified) && (
                            <>
                                <Text header={2} size="h6" bold={true} variant="yellow">Create account</Text>
                                <Text variant="white" bold={true}>Access free market insights and fee-based reclamation tools.</Text>
                            </>)}
                    </div>
                    <div id="create-account-details-wrapper" className="product-vertical-container flex-1 align-center v-gap-xl">
                        <div className="product-vertical-container flex-1 width-100 v-gap-m">
                            <input readOnly={keystoneInterfaceModalType === 'create-account-invite'} id="create-account-email-input" className="sf-mono size-m" type="email" placeholder="Email Address" value={userEmail} onChange={(e) => setUserEmail(e.target.value)}/>
                            <button className="create-account-button" onClick={handleCredentialAccountCreateClick} disabled={!userEmail || !isValidEmail(userEmail)}>
                                <Text variant={(!userEmail || !isValidEmail(userEmail)) ? "secondary" : ""} bold={true}>Create Account</Text>
                            </button>
                        </div>
                        <Divider label="or" />
                        <div className="product-vertical-container flex-1 width-100 v-gap-l align-center">
                            <button className="create-account-button with-logo relative" onClick={handleGoogleAccountCreateClick}>
                                <img src={google} alt="Google's 'G' Logo"/>
                                <Text bold={true}>Sign up with Google</Text>
                                <SimpleLoader loading={loginLoading} size={28} />
                                <img src={google} alt="Google's 'G' Logo"/>
                            </button>
                            <Text size="caption" bold={true} variant="secondary">Note: Organization email address must be used.</Text>
                        </div>
                        <a href='/privacy' id="create-account-privacy-anchor" className="size-s secondary">Privacy Policy</a>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default React.memo(CreateAccount);